import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Thankyou = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography variant="h4" gutterBottom>
        Thank You for Reaching Out!
      </Typography>
      <Typography variant="body1" sx={{ maxWidth: "500px", marginBottom: "2rem" }}>
        We appreciate your message and will get back to you as soon as we can.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate("/")}>
        Return Home
      </Button>
    </Box>
  );
};

export default Thankyou;
